import { PROGRESS_STATES } from 'constants/enums'


export const tableHeaders = (isLabelsEnabled = false) => {
  return [
    {
      id: 0,
      label: '',
      intlKey: '',
      sortableId: '',
      selector: true
    },
    {
      id: 1,
      label: 'ID',
      intlKey: 'table.id',
      sortableId: 'id'
    },
    {
      id: 2,
      label: 'First Name',
      intlKey: 'table.first_name',
      sortableId: 'awardLeaderRegistration.firstName'
    },
    {
      id: 3,
      label: 'Last Name',
      intlKey: 'table.last_name',
      sortableId: 'awardLeaderRegistration.lastName'
    },
    {
      id: 4,
      label: 'Registration Date',
      intlKey: 'table.registration_date',
      sortableId: 'awardLeaderRegistration.createdAt'
    },
    {
      id: 5,
      label: 'Email',
      intlKey: 'table.email',
      sortableId: 'awardLeaderRegistration.email'
    },
    {
      id: 6,
      label: 'Award Unit',
      intlKey: 'table.award_unit',
      sortableId: 'organization.name'
    },
    {
      id: 8,
      label: 'Main Award Leader',
      intlKey: 'table.main_award_leader',
      sortableId: 'awardLeaderRegistration.isCoordinator'
    },
    {
      id: 12,
      label: 'Labels',
      intlKey: 'table.labels',
      sortableId: 'labels.label.name',
      hide: !isLabelsEnabled
    },
    {
      id: 11,
      label: 'Review',
      intlKey: 'table.review'
    },
    {
      id: 12,
      label: 'Action',
      intlKey: 'table.action'
    }
  ]
}


export const bulkAwardLeaderStateOptions = intl => {
  const options = []

  options.push({
    value: PROGRESS_STATES.awardRegApproval.id,
    label: intl.formatMessage({ id: 'button.approve', defaultMessage: 'Approve' })
  })

  return options
}

export const bulkForm = 'tasks-registrationAwardLeaders-bulkChange'
